import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Query } from 'react-apollo';

import { queryDepartmentDetails } from 'src/GraphQL/query/Department.query';

import DepartmentCardContainer from './DepartmentCard';

export default class DepartmentCard extends Component {
  static propTypes = {
    depId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  };

  render() {
    const { depId, ...restProps } = this.props;
    return (
      <Query
        query={queryDepartmentDetails}
        variables={{
          depId,
          showEvents: false,
          includeRound: true,
          showLikes: true,
          roundDetails: true,
        }}
      >
        {({ loading, error, data }) => {
          if (loading) return <div>Loading</div>;
          if (error) return <div>{JSON.stringify(error)}</div>;
          if (data === null) return <div />;
          return <DepartmentCardContainer data={data.department} depId={depId} {...restProps} />;
        }}
      </Query>
    );
  }
}
